import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { Row, Col } from "react-flexbox-grid";
import { inject, observer } from "mobx-react";

@inject("confirmationModalStore")
@observer
export default class ConfirmationModal extends Component {
  render() {
    const { Header, Body, Footer, Title } = Modal;
    const {
      isVisible,
      toggleVisibility,
      getModalData
    } = this.props.confirmationModalStore;

    return (
      <Modal show={isVisible} onHide={toggleVisibility}>
        <Header closeButton>
          <Title>{getModalData.title}</Title>
        </Header>
        <Body>
          <div style={{ fontSize: 14, textAlign: "center" }}>
            {!Array.isArray(getModalData.body)
              ? getModalData.body
              : getModalData.body.map((line, index) => {
                  return (
                    <div
                      key={index}
                      style={
                        index === 0
                          ? { fontSize: 14, marginBottom: 20 }
                          : { textAlign: "left", marginTop: 10 }
                      }
                    >
                      {line instanceof Object
                        ? Object.entries(line).map((entry, index) => {
                            return (
                              <li key={index} style={{ textIndent: 10 }}>
                                {entry[0] + ": " + entry[1]}
                              </li>
                            );
                          })
                        : line}
                    </div>
                  );
                })}
          </div>
        </Body>
        <Footer>
          <Row>
            <Col md={12} style={{ textAlign: "right" }}>
              <Button bsStyle="danger" onClick={toggleVisibility}>
                {getModalData.rejectText}
              </Button>
              <Button
                bsStyle="primary"
                onClick={() => {
                  getModalData.onConfirm();
                  toggleVisibility();
                }}
              >
                {getModalData.confirmText}
              </Button>
            </Col>
          </Row>
        </Footer>
      </Modal>
    );
  }
}
